export default __webpack_public_path__ + "static/media/Asset1.00612059.png";